import { Outlet, Navigate } from 'react-router';
import { useLogin } from '../../hooks/useLogin';
import { Loader } from '@f2m3/shared-frontend-ui';
import Forbidden from '../../pages/admin/Forbidden';
import ImpersonationBanner from './ImpersonationBanner';
import { isStaff } from '../../auth/roles';

const AdminRoute = () => {
  const { userData, isLoggedIn, isPending, impersonation } = useLogin();

  if (isPending) {
    return <Loader />;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // Staff (admins AND account_sales) may enter /admin. Every pre-existing
  // admin page is additionally wrapped in AdminOnlyRoute (router.tsx), so a
  // sales-only user reaches only the landing and the Relations section.
  if (!isStaff(userData?.roles)) {
    // The backend's role ceiling strips admin roles from every impersonated
    // principal (docs/superpowers/specs/2026-08-19-enduser-impersonation-design.md),
    // so an admin who follows an /admin/... link while impersonating lands
    // here — this branch renders OUTSIDE both MainLayout and AdminLayout
    // (see router.tsx: "/admin" is a top-level route), so it is the one
    // place ImpersonationBanner has to be mounted explicitly rather than
    // inheriting it from a layout. Without this, the banner (and the only
    // way back) would silently vanish on exactly the page an impersonating
    // admin is most likely to land on by mistake.
    return (
      <>
        <ImpersonationBanner />
        <Forbidden impersonating={Boolean(impersonation)} />
      </>
    );
  }

  return <Outlet />;
};

export default AdminRoute;
